import React from 'react';

import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar'

import Indicator from '../containers/Indicator'

export default class AnsweredDimension extends React.Component  {

    componentDidMount() {
        const {fetchAnswersIfNeeded, parentId,cpId, dimensionId} = this.props
        fetchAnswersIfNeeded(parentId,cpId, dimensionId)
    }


    render() {
      const {cpId, dimensionId,answerId, item, handleTextOnChange, parentId, errorMessage } = this.props
      return <div  className="ms-Grid-row">
        <div className="ms-Grid-col ms-lg12">
            
            {errorMessage && errorMessage.id === dimensionId 
                ? <MessageBar
                messageBarType={ MessageBarType.error }
                isMultiline={ false }>
                There was a problem saving your answer
                </MessageBar>
                : ''}        
        </div>
        <div  className="ms-Grid-col ms-lg2" > </div>
        {item.indicators ? Object.entries(item.indicators).map( ( [indicatorId,indicator] ,i) => 
            <span>{answerId === indicatorId ? indicator.text : '' }</span>
            )
            :  <span>Loading</span>}
       </div>
    }
}




// WEBPACK FOOTER //
// ./src/activities/components/AnsweredDimension.js